export default __webpack_public_path__ + "static/media/work.fb1c5426.jpg";